import { useState } from "react";

import FiltrosListarCluster from '../../components/ListarCluster/FiltroListarCluster';
import TabelaListarCluster from '../../components/ListarCluster/TabelaListarCluster';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';
import AdminSection from "../../components/AdminSection/AdminSection";  

import { IntersectThree } from "@phosphor-icons/react";

import "./indexListar.css"  
export default function ListarClusterAdm() {
    //Notifier
    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });

    //Filtros
    const [ filtros, setFiltros ] = useState({
        id_cluster: 0,
        id_filiais: 0 
    });

    //Data 
    const [ cluster, setCluster ] = useState(null);
    //Utils
    const [ load, setLoad ] = useState(false);


    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        
        <AdminSection
            etapa={<IntersectThree style={{width: '30px', height: '30px'}}/>} titulo={'Clusters'}  contexto={'Todos os clusters estão citados na lista abaixo.'}
        >
            <div className="p-8">
                <div className="mb-8">
                    <FiltrosListarCluster 
                        filtros={filtros}
                        setCluster={setCluster}
                        setFiltros={setFiltros}
                        setLoad={setLoad}
                    />
                </div>

                <div className="paddingTable">
                    <TabelaListarCluster 
                        cluster={cluster}
                        filtros={filtros}
                        setNotifier = {(isSuccess, message) => setNotify({
                            isActive: true,
                            isSuccessful: isSuccess,
                            message: message
                        })}
                    />
                </div>
            </div>

        </AdminSection>
        
        
    </>
}